import { useEffect, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ScreenshotPreviewProps {
 screenshot: Blob;
 onRemove: () => void;
 disabled?: boolean;
}

export function ScreenshotPreview({ screenshot, onRemove, disabled }: ScreenshotPreviewProps) {
 const url = useMemo(() => URL.createObjectURL(screenshot), [screenshot]);

 useEffect(() => {
 return () => {
 URL.revokeObjectURL(url);
 };
 }, [url]);

 return (
 <div className="flex items-start gap-3 rounded-lg border p-3">
 <img
 src={url}
 alt="Screenshot preview"
 className="h-24 w-40 rounded object-cover border"
 />
 <div className="flex-1">
 <div className="text-sm font-medium">Screenshot</div>
 <div className="text-xs text-muted-foreground">Will be attached to your report.</div>
 </div>
 <Button
 type="button"
 variant="ghost"
 size="icon"
 onClick={onRemove}
 disabled={disabled}
 className="shrink-0"
 >
 <X className="h-4 w-4" />
 </Button>
 </div>
 );
}
